export function l(msg) {
    console.log(msg);
}
